/** @format */

import { getApi } from 'api/axios';
import { useState } from 'react';
import { useSelector } from 'react-redux';

export const useModificationLogic = () => {
  const [printingPrices, setPrintingPrices] = useState();
  const shopTier = useSelector((state) => state.nonPersistedReducers?.shopTierSliceReducer?.shopTier);
  const getCurrentModifiers = (currentGroup, availableModifiers) => {
    let currentModifiers = [...availableModifiers];
    let currentModifierIds = [];
    let avaialableModifierIds = [];
    if (currentGroup) {
      currentGroup?.modifiers?.forEach((m) => {
        currentModifierIds.push(m.id);
      });
      availableModifiers?.forEach((m) => avaialableModifierIds.push(m.id));
    }
    // For now, modifiers are enabled by default which could result in a strange behaviour (objects with null unit price)
    currentModifiers = currentModifiers?.map((modifier) => {
      let newModifier = { ...modifier };
      newModifier.enabled = false;
      // Prio 1 modifiers have no price - customer request
      newModifier.unitPrice = {
        grossAmount: 0,
        vatAmount: 0,
        netAmount: 0,
        taxRate: 0,
        currency: 'HUF'
      };
      newModifier.validUntil = shopTier?.galleryExpiryDate
        ? new Date(new Date().setUTCHours(23, 59, 59, 999))
        : new Date(new Date().setFullYear(new Date().getFullYear() + 50));
      return newModifier;
    });
    if (currentGroup === null) {
      // This is a create.
    } else {
      // This is an update.

      currentModifiers?.forEach((cm) => {
        if (
          currentGroup?.modifiers?.find((cgm) => getUriId(cgm.modifierUriSegment) === getUriId(cm.modifierUriSegment))
        ) {
          let foundModi = currentGroup?.modifiers?.find(
            (cgm) => getUriId(cgm.modifierUriSegment) === getUriId(cm.modifierUriSegment)
          );
          currentModifiers = currentModifiers.filter((m) => m.id !== cm.id);
          currentModifiers.push({
            ...cm,
            enabled: foundModi.enabled,
            validUntil: currentGroup?.productGroupModifierValidities?.find(
              (v) => v.modifierUriSegment === cm.modifierUriSegment
            )?.validUntil,
            unitPrice: { ...foundModi.unitPrice }
          });
          // currentModifiers = currentModifiers.map(
          //   (m) =>
          //     m.id === cm.id && {
          //       ...m,
          //       enabled: foundModi.enabled,
          //       validUntil: foundModi.validUntil,
          //       unitPrice: { ...foundModi.unitPrice },
          //     }
          // );
        }
      });

      // if(currentModifierIds?.sort()?.join(',') === avaialableModifierIds?.sort()?.join(',')){
      //   currentGroup?.modifiers?.forEach((currentGroupModifier) => {
      //     currentModifiers = currentModifiers?.filter(
      //       (m) => m.id !== currentGroupModifier.id
      //     );
      //     currentModifiers.push(currentGroupModifier);
      //   });
      // }
    }
    return currentModifiers;
  };

  const modiGroupComparator = (a, b) => {
    return a.priority < b.priority || (a.priority === b.priority && a.name < b.name)
      ? -1
      : a.priority > b.priority || (a.priority === b.priority && a.name >= b.name)
      ? 1
      : 0;
  };

  const getUriId = (segment) => {
    return +segment.match('mod#id:[0-9]*')[0]?.split(':')[1];
  };

  const separatePrios = (modifications) => {
    let curPrio = modifications?.length > 0 ? modifications[0]?.priority : 0;
    let separatedPrios = [];
    let curIdx = 0;
    modifications?.forEach((curModi) => {
      if (curModi.priority === curPrio) {
        if (separatedPrios[curIdx] == null) {
          separatedPrios[curIdx] = [];
        }
        separatedPrios[curIdx].push(curModi);
      } else {
        // we have reached a modification which has a higher prio than current
        curPrio = curModi.priority;
        curIdx = curIdx + 1;
        if (separatedPrios[curIdx] == null) {
          separatedPrios[curIdx] = [];
        }
        separatedPrios[curIdx].push(curModi);
      }
    });
    return separatedPrios;
  };

  const getModificationList = (modifiers) => {
    if (modifiers?.length === 0) return [];
    let prioSorted = modifiers?.sort(modiGroupComparator); // one array, sorted by prio
    let separatedPrioModis = separatePrios(prioSorted);

    let modifierList = [];
    separatedPrioModis[0].forEach((format) => {
      modifierList.push(format);
      if (separatedPrioModis?.length > 1) {
        separatedPrioModis[1].forEach((modifier) => {
          if (format.compatibleGroup === modifier.compatibleGroup) {
            modifierList.push(modifier);
          }
        });
      }
    });
    return modifierList;
  };
  const [inputDisabled, setInputDisabled] = useState(false);
  const setModification = async ({
    currentModifiers,
    newModificationId,
    value,
    setCurrentModifiers,
    grossAmount,
    taxRate,
    tax
  }) => {
    let foundModification = currentModifiers?.find((modification) => modification.id === newModificationId);
    let modificationsWithoutFoundModification = currentModifiers?.filter(
      (modification) => modification.id !== newModificationId
    );

    setInputDisabled(true);
    if (foundModification) {
      let updatedModification = {
        ...foundModification,
        unitPrice: {
          //TaxRateComment0.3 When taxRate is not 0.00, it will be necessary to change the backend to accept netAmount from here and not grossAmount
          grossAmount: tax ? grossAmount : value,
          currency: 'HUF',
          //TaxRateComment0.2 And here!!!!
          taxRate: tax ? value : taxRate,
          netAmount: 0,
          vatAmount: 0
        }
      };

      if (foundModification.priority === 1) {
        // in this case the value is a boolean
        updatedModification['enabled'] = value;
        updatedModification['unitPrice'] = {
          grossAmount: 0,
          vatAmount: 0,
          currency: 'HUF',
          taxRate: 0
        };
      }
      setCurrentModifiers([...modificationsWithoutFoundModification, updatedModification]);
    }

    setInputDisabled(false);
  };

  const getModificationEnabled = (id, currentModifiers) => {
    let foundModification = currentModifiers?.find((modification) => modification.id === id);
    return foundModification?.enabled || false;
  };

  const findAvailableCompatibles = (compatibles, modifiers) => {
    let found = false;
    modifiers.find(
      (modifier) => modifier?.compatibleGroup === compatibles && modifier.enabled === true && modifier?.priority === 2
    )
      ? (found = true)
      : (found = false);

    return found;
  };

  const setModificationAvailable = async (
    newModificationId,
    modifierUriSegment,
    available,
    currentModifiers,
    setCurrentModifiers,
    priority,
    compatibleGroup
  ) => {
    const modifiedModifiers = await currentModifiers.map((modifier) => {
      if (priority === 1) {
        if (modifier.id === newModificationId || modifier.compatibleGroup === compatibleGroup) {
          return { ...modifier, enabled: available };
        }
      } else {
        if (modifier.id === newModificationId) {
          return { ...modifier, enabled: available };
        }
        if (modifier.compatibleGroup === compatibleGroup && available && modifier?.priority === 1) {
          return { ...modifier, enabled: available };
        }

        return modifier;
      }

      return modifier;
    });
    const availableModifiers = modifiedModifiers.map((modifier) => {
      if (priority === 2) {
        if (modifier.compatibleGroup === compatibleGroup && !available) {
          //THIS IS NEEDED TO BE MODIFIED
          if (findAvailableCompatibles(modifier.compatibleGroup, modifiedModifiers)) {
            return modifier;
          } else {
            return { ...modifier, enabled: false };
          }
        }
        return modifier;
      }
      return modifier;
    });

    setCurrentModifiers(availableModifiers);
  };

  const getPrintingPrice = async () => {
    try {
      const res = await (
        await getApi({ baseUrl: window._env_.REACT_APP_QDAK_ORDER_URL })
      ).get(`/admin/delivery-vendor-options/latest`);
      setPrintingPrices(res?.data);
    } catch (e) {
      console.log(e);
    }
  };

  const handleSubmitClick = (submitButtonRef) => {
    submitButtonRef.current.click();
  };

  const clearModifiers = (modifiers) => {
    const newModis = modifiers.map((m) => {
      delete m.visibleValidUntil;
      delete m.validUntil;

      delete m.commission;
      delete m.total;
      if (!m.unitPrice) {
        m.unitPrice = {
          netAmount: 0,
          vatAmount: 0,
          grossAmount: 0,
          currency: 'HUF',
          taxRate: 0
        };
      }
      if (m.unitPrice) return m;
    });
    return newModis;
  };

  return {
    getCurrentModifiers,
    modiGroupComparator,
    getModificationList,
    setModification,
    setModificationAvailable,
    handleSubmitClick,
    getModificationEnabled,
    clearModifiers,
    inputDisabled,
    getUriId,
    getPrintingPrice,
    printingPrices
  };
};
